// extracted by mini-css-extract-plugin
module.exports = {"industry":"card-module--industry--IFwws","button":"card-module--button--1OBfT","iconHolder":"card-module--icon-holder--2bs7K","icon":"card-module--icon--1jHl-"};